export enum AdminImportType {
  ACCOUNT,
  CLIENT,
}

export namespace AdminImportType {
  let elements = [AdminImportType.ACCOUNT, AdminImportType.CLIENT];
  let alias = "com.bcdfx.api.servicerequest.AdminImportType";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
